/**
 * The browser's and the operating system's names from the user agent (no versions but the browser's major one): shared by the
 * error report (every build, src/beta/errorReport.ts) and "Report a problem on this page" (preview builds, src/beta/report.ts).
 * Its own module so the error report does not pull the preview report's code into a production build.
 */

/** The browser's name and major version from its user agent ("Chrome 141", "Samsung Internet 30"); "unknown" otherwise. */
export function browserOf(ua: string): string {
  const tests: [string, RegExp][] = [
    ['Edge', /\bEdg(?:e|A|iOS)?\/(\d+)/],
    ['Samsung Internet', /\bSamsungBrowser\/(\d+)/],
    ['Opera', /\b(?:OPR|OPiOS)\/(\d+)/],
    ['Firefox', /\b(?:Firefox|FxiOS)\/(\d+)/],
    ['Chrome', /\b(?:CriOS|Chrome)\/(\d+)/],
    ['Safari', /\bVersion\/(\d+)[\d.]*.*\bSafari\//],
  ];
  for (const [name, re] of tests) {
    const m = re.exec(ua);
    if (m?.[1]) return `${name} ${m[1]}`;
  }
  return 'unknown';
}

/** The operating system's name from the user agent (no version); "unknown" otherwise. */
export function osOf(ua: string): string {
  const tests: [string, RegExp][] = [
    ['Android', /\bAndroid\b/],
    ['iPadOS', /\biPad\b/],
    ['iOS', /\b(iPhone|iPod)\b/],
    ['ChromeOS', /\bCrOS\b/],
    ['Windows', /\bWindows\b/],
    ['macOS', /\bMac OS X\b|\bMacintosh\b/],
    ['Linux', /\bLinux\b|\bX11\b/],
  ];
  for (const [name, re] of tests) if (re.test(ua)) return name;
  return 'unknown';
}
